import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../api/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoService {
  constructor(private authService: AuthService) {}

  fetchPhotoUrl(email: string): Observable<string | null> {
    const token = this.authService.token;
    if (!token || !email) {
      return of(null);
    }
    return this.authService.getProfilePhoto(token, email).pipe(
      map((blob: Blob) => {
        if (blob && blob.size > 0 && blob.type.includes('image')) {
          return URL.createObjectURL(blob);
        }
        return null;
      }),
      catchError((err) => {
        return of(null);
      }),
    );
  }
}
